export default {
  en: {
    close: 'Close',
  },
  ru: {
    close: 'Закрыть',
  },
  de: {
    close: 'Schließen',
  },
  pt: {
    close: 'Fechar',
  },
  fr: {
    close: 'Fermer',
  },
  es: {
    close: 'Cerrar',
  },
};
